import { FC } from 'react';
import { ISectionPromoBanner } from '@belong/types';
import { PromoBanner, Section } from '@belong/ui-components';

const SectionPromoBanner: FC<ISectionPromoBanner> = props => {
  const { id, identifier, sectionStyles, ...otherProps } = props;
  return (
    <Section data-contentid={id} data-testid="section-banner" data-identifier={identifier} {...sectionStyles}>
      <PromoBanner {...otherProps} />
    </Section>
  );
};

export default SectionPromoBanner;
